let routes = [
  {
    path: '/redirection-illuxi',
    component: () => import('../views/RedirectionIlluxi.vue'),
  }
]

export default routes;